import get from 'lodash/get'

/**
 * Read a dimension mapping's `config.aggregation` as one aggregator name per
 * mapped column.
 *
 * The value is meant to be an array, but a bare string turns up from older
 * projects, from templates, and from any dimension that was only ever mapped
 * to a single column. Every caller either spreads it, filters it, or reorders
 * it — and a string survives all three without complaint: `[..."sum"]` is
 * `["s","u","m"]`, which then gets persisted back into the mapping as
 * aggregator names and makes the core throw `Aggregator "s" is not
 * registered`. Reading through here is what stops that.
 */
export function getAggregationList(mapping, columnCount) {
  const value = get(mapping, 'config.aggregation')

  if (Array.isArray(value)) return value

  if (typeof value === 'string' && value) {
    const count = Number.isFinite(columnCount)
      ? columnCount
      : get(mapping, 'value.length', 1)
    return Array(Math.max(count, 1)).fill(value)
  }

  return []
}
